module.exports = '2.1.1';



//////////////////
// WEBPACK FOOTER
// ./~/graphlib/lib/version.js
// module id = 125
// module chunks = 0